const NAME = "EVALUATION_PROCESS_DEFINITION";

export default NAME;